// extracted by mini-css-extract-plugin
export default {"container":"AN-z","dimension":"BN-z","dimensionLabels":"CN-z"};